import React from "react";
import "../AlgoTrading.css";

const Orders = () => (
  <main className="algo-page">
    <header className="algo-page-heading"><div><h1>Orders</h1><p>Track all orders placed by your strategies.</p></div></header>
    <section className="algo-filter-bar"><input type="date" /><select><option>All Brokers</option></select><select><option>All Strategies</option></select><select><option>All Statuses</option><option>COMPLETE</option><option>OPEN</option><option>REJECTED</option></select></section>
    <section className="algo-content-card"><div className="algo-table-wrap"><table className="algo-table"><thead><tr><th>Order ID</th><th>Strategy</th><th>Symbol</th><th>Side</th><th>Quantity</th><th>Price</th><th>Status</th><th>Time</th></tr></thead><tbody><tr><td colSpan="8"><div className="algo-empty compact"><i className="fa fa-list-alt"></i><h2>No orders yet</h2><p>Strategy orders will appear here.</p></div></td></tr></tbody></table></div></section>
  </main>
);

export default Orders;
